module.exports = __webpack_public_path__ + "05_short_beige.7458fd49.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_short_beige.png
// module id = +bZA
// module chunks = 0